import React, { useEffect, useState } from "react";
import { Box, Typography, Avatar, Stack } from "@mui/material";
import ApiService from "../../services/api-service";
import Loader from "../../components/Loader";
import notifier from "../../components/Notifier";

const FeaturedArtists = () => {
  const [featuredArtists, setFeaturedArtists] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch Featured Artists
  const fetchFeaturedArtists = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FEATURE_ARTIST("");
      setFeaturedArtists(response?.result || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching featured artists:", error);
      setLoading(false);
      notifier.error("Failed to fetch featured artists. Please try again later.");
    }
  };

  useEffect(() => {
    fetchFeaturedArtists();
  }, []);

  const handleArtistClick = (artistId) => {
    // Navigate by directly changing the browser's location
    window.location.href = `/app/ArtistProfile/${artistId}`;
  };

  if (loading) {
    return <Loader message="Loading Featured Artists..." />;
  }

  return (
    <Box sx={{ padding: "20px 0", color: "#fff" }}>
      {/* Section Title */}
      <Typography
        variant="h6"
        sx={{
          color: "#FFFFFF",
          fontWeight: "bold",
          fontFamily: "Inter, sans-serif",
          alignSelf: "flex-start",
          marginBottom: "20px",
          paddingLeft: "20px", // Align with content
        }}
      >
        Featured Artists
      </Typography>

      {/* Horizontal Scrollable Artists */}
      <Box
        sx={{
          display: "flex",
          gap: "20px",
          overflowX: "auto",
          padding: "10px 20px",
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar
          },
        }}
      >
        {featuredArtists.length > 0 ? (
          featuredArtists.map((artist) => (
            <Box
              key={artist._id}
              sx={{
                flex: "0 0 auto",
                width: "160px", // Adjust size for larger images
                textAlign: "left", // Align text to the left
                padding: "10px",
                borderRadius: "12px",
                cursor: "pointer",
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)", // Slight zoom on hover
                },
              }}
              onClick={() => handleArtistClick(artist._id)} // Navigate to artist page on click
            >
              {/* Square Profile Image with Rounded Corners */}
              <Avatar
                src={artist.profileImg?.filePath || "/default-avatar.jpg"}
                alt={`${artist.firstName} ${artist.lastName}`}
                sx={{
                  width: 140, // Larger image size
                  height: 140,
                  borderRadius: "12px", // Rounded corners for square image
                  marginBottom: "10px",
                }}
              />

              {/* Artist Name */}
              <Typography
                sx={{
                  fontSize: "14px", // Match text size
                  fontWeight: "bold",
                  color: "#FFFFFF",
                  fontFamily: "Inter, sans-serif",
                }}
              >
                {artist.firstName} {artist.lastName || ""}
              </Typography>

            </Box>
          ))
        ) : (
          <Typography
            sx={{
              fontSize: "14px", // Match fallback text size
              color: "#CCCCCC",
              textAlign: "center",
            }}
          >
            No Featured Artists Found
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default FeaturedArtists;
